import { useRequestLotteries } from '~/repositories'

/** Fetches the latest lottery notification entries from the lotteries API. */
export const getNotification = () => {
	return useRequestLotteries('get', `/notification`)
}

export default {
	getNotification,
}
